import React, { useState } from 'react';
import { MdPeopleOutline } from "react-icons/md";
import { GrDocumentPerformance } from "react-icons/gr";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import { FaCalendar, FaUserCheck } from "react-icons/fa";
import WorkforceImage from '../assests/Workforce.png';
import Performance from '../assests/Performance.png';
import Payroll from '../assests/Payroll.png';
import Attendance from '../assests/attendance.png';
import Recriutment from '../assests/Recriutment.png';
import Hrmslogo from '../assests/hrms2.png';
import slider from '../assests/slider2.png';
import './Login.css';

const Login = () => {

    const [isSignUp, setIsSignUp] = useState(false);
    const toggleForm = () => {
        setIsSignUp(!isSignUp);
    };

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const [activeSection, setActiveSection] = useState('workforce');

    const handleClick = (section) => {
        setActiveSection(section);
    };

    const [showLogin, setShowLogin] = useState(false);
    const [animateLogin, setAnimateLogin] = useState(false);
    const [animateClose, setAnimateClose] = useState(false);

    const handleLoginClick = () => {
        if (showLogin) {
            setAnimateClose(true);
            setTimeout(() => {
                setShowLogin(false);
                setAnimateClose(false);
            }, 600);
        } else {
            setShowLogin(true);
            setAnimateLogin(true);
            setTimeout(() => setAnimateLogin(false), 600);
        }
    };

    const faqs = [
        {
            question: "What is HRMS software, and how can it benefit my business?",
            answer: "An HRMS (Human Resource Management System) helps businesses automate HR tasks like payroll, employee onboarding, attendance, performance management, and compliance. It streamlines HR operations, enhances employee experience, and ensures data accuracy.",
        },
        {
            question: "Why should I choose HROne over other HR software providers in India?",
            answer: "HROne is one of the best HRMS software in India, trusted by 2000+ companies. Our platform offers HR payroll software, HR attendance and payroll software, and compliance management, making HR operations seamless for businesses of all sizes. Plus, HROne is rated #2 globally in the Easiest-to-Use HR software category, ensuring a user-friendly experience for HR teams.",
        },
        {
            question: "Is HROne suitable for startups and SMEs?",
            answer: "Yes! HROne provides HR software for startups and small to medium-sized businesses, offering cost-effective and scalable HR solutions tailored to their growth needs.",
        },
        {
            question: "What makes HROne the best HR software in India?",
            answer: "HROne is an intuitive, feature-rich HRIS software that automates complex HR functions, offers seamless integrations, and ensures compliance, making it a top choice among businesses in India.",
        },
        {
            question: "How does HROne help with payroll and attendance management?",
            answer:
                "Our HR attendance and payroll software automates salary processing, leave tracking, shift scheduling, and statutory compliance, reducing errors and saving time.",
        },
    ];

    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className='outer'>


            {/* header */}
            <div className='hrms-header'>
                <div className='hrms-header-logo'>
                    <img className='hrms-img' src={Hrmslogo} alt="HRMS Logo" />
                </div>
                <div className='hrms-header-btn'>
                    <button className="hrms-lo" type="button" onClick={handleLoginClick}>
                        Login
                    </button>

                </div>
            </div>


            {/* login */}
            {showLogin && (
                // <div className={`login-container ${animateLogin ? 'login-animate' : ''}`}>
                <div className={`login-container ${animateLogin ? 'login-animate' : ''} ${animateClose ? 'login-animate-close' : ''}`}>
                    {/* Left Side */}
                    <div className="login-left">
                        <div className="login-content">
                            <h1 className='login-h1'>One HRMS to Handle It All.</h1>
                            <h1 className='login-h1'>Fast. Simple. Scalable.</h1>
                            <h2 className='login-h2'>From hire to retire HR, in just a few clicks.</h2>

                            <ul className="features">
                                <li className='login-li'>3x faster HR tasks with built-in AI suite (+ AI Agent)</li>
                                <li className='login-li'>Replace 20+ tools with all-in-one HR system</li>
                                <li className='login-li'>50 or 5,000 employees, scale your HR without stress</li>
                            </ul>

                            <div className="reviews">
                                <p className='login-p'>⭐ 1,740+ Reviews | G2: 4.8</p>
                                <p className='login-p'>⭐ 650+ Reviews | Gartner: 4.9</p>
                            </div>
                        </div>
                    </div>
                    {/* Right Side (Form) */}
                    <div className="login-right">
                        <div className="login-form-box">
                            <form>
                                {/* Dynamic Form Header */}
                                <h2 className='form-h2'>{isSignUp ? 'Create an Account' : 'See HROne Live'}</h2>
                                {/* Dynamic Form Fields */}
                                {isSignUp ? (
                                    <>
                                        <input className='input1' type="text" placeholder="Enter Your Name" required />
                                        <input className='input1' type="email" placeholder="Enter Your Email" required />
                                        <div className="phone-row">
                                            <input className='input1' type="tel" placeholder="Enter Your Phone Number" required />
                                        </div>
                                        <div className="password-field">
                                            <input className='input1' type="password" placeholder="Enter Your Password" required />
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <input className='input1' type="email" placeholder="Enter Your Email" required />
                                        <div className="password-field">
                                            <input className='input1' type="password" placeholder="Enter Your Password" required />
                                        </div>
                                    </>
                                )}

                                <button className="login-sub" type="submit">{isSignUp ? 'Sign Up' : 'Login'}</button>

                                {/* Footer */}
                                <p className="form-footer">
                                    By submitting, you agree to our <a className='form-a' href="#">Terms</a> & <a href="#">Privacy Policy</a>.
                                </p>

                                {/* Toggle between Login and Sign Up */}
                                <div className="signup-option">
                                    <p>
                                        {isSignUp ? (
                                            <>
                                                Already have an account? <a className='form-a' href="#" onClick={toggleForm}>Login</a>
                                            </>
                                        ) : (
                                            <>
                                                Don't have an account? <a className='form-a' href="#" onClick={toggleForm}>Sign Up</a>
                                            </>
                                        )}
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>

                    <div className="wave-divider">
                        <svg className='wave-svg' viewBox="0 0 500 150" preserveAspectRatio="none">
                            <path d="M-6.59,83.37 C149.99,150.00 349.99,0.00 505.45,80.36 L500.00,150.00 L0.00,150.00 Z"
                                style={{ stroke: "none", fill: "#ffffff" }}></path>
                        </svg>
                    </div>
                </div>
            )}

            {/* slider */}
            <div className='slider-img'>
                <img className='slider-img1' src={slider} alt="slider" />
            </div>

            {/* hr section */}

            <div className="hr-section">
                <header className='hr-header'>
                    <h1 className='hr-h1'>Hire to retire? HROne does it all</h1>
                    <p className='hr-p'>The only HR solution you’ll ever need</p>
                    <div className="icons">
                        <div className="icon" onClick={() => handleClick('workforce')}>
                            <MdPeopleOutline />
                            <span className='hr-span'>Workforce</span>
                        </div>
                        <div className="icon" onClick={() => handleClick('performance')}>
                            <GrDocumentPerformance />
                            <span className='hr-span'>Performance</span>
                        </div>
                        <div className="icon" onClick={() => handleClick('payroll')}>
                            <RiMoneyRupeeCircleFill />
                            <span className='hr-span'>Payroll</span>
                        </div>
                        <div className="icon" onClick={() => handleClick('attendance')}>
                            <FaCalendar />
                            <span className='hr-span'>Attendance</span>
                        </div>
                        <div className="icon" onClick={() => handleClick('recruitment')}>
                            <FaUserCheck />
                            <span className='hr-span'>Recruitment</span>
                        </div>
                    </div>
                </header>

                {/* Content Section */}
                {activeSection === 'workforce' && (
                    <div className="content-section">
                        <div className="left">
                            <h2 className='left-h2'>Simplify Your Workforce Management</h2>
                            <p className='left-p'>
                                Easily manage employee lifecycles with HROne from onboarding to offboarding, handle every HR task.
                            </p>
                        </div>
                        <div className="right">
                            <img className='right-img' src={WorkforceImage} alt="Workforce Management" />
                        </div>
                    </div>
                )}

                {activeSection === 'performance' && (
                    <div className="content-section">
                        <div className="left">
                            <h2 className='left-h2'>Boost Your Team’s Performance with Ease</h2>
                            <p className='left-p'>
                                Set measurable goals and track KPIs, automate performance reviews, provide 360-degree feedback, and ensure unbiased review cycle.
                            </p>
                        </div>
                        <div className="right">
                            <img className='right-img' src={Performance} alt="Workforce Management" />
                        </div>
                    </div>
                )}

                {activeSection === 'payroll' && (
                    <div className="content-section">
                        <div className="left">
                            <h2 className='left-h2'> Take the Stress Out of Your Payroll</h2>
                            <p className='left-p'>
                                Automate salary calculations, handle compliance with ease, and generate payslips instantly to ensure error-free payroll everytime.
                            </p>
                        </div>
                        <div className="right">
                            <img className='right-img' src={Payroll} alt="Workforce Management" />
                        </div>
                    </div>
                )}
                {activeSection === 'attendance' && (
                    <div className="content-section">
                        <div className="left">
                            <h2 className='left-h2'>Track Your Team’s Attendance, Effortlessly</h2>
                            <p className='left-p'>
                                Mark attendance in real-time with geofencing, facial recognition, and mobile punch-ins and make every day count with HRMS.
                            </p>
                        </div>
                        <div className="right">
                            <img className='right-img' src={Attendance} alt="Workforce Management" />
                        </div>
                    </div>
                )}

                {activeSection === 'recruitment' && (
                    <div className="content-section">
                        <div className="left">
                            <h2 className='left-h2'>Find and Hire Your Perfect Team, Faster</h2>
                            <p className='left-p'>
                                Post jobs to multiple portals, utilise AI resume parser, and schedule interviews with ease for a smooth hiring experience.
                            </p>
                        </div>
                        <div className="right">
                            <img className='right-img' src={Recriutment} alt="Workforce Management" />
                        </div>
                    </div>
                )}
            </div>


            {/* pricing */}
            <div className="pricing-container">
                <div className="pricing-header">
                    <h2 className='price-h2'>Choose your pricing plan</h2>
                    <p className='price-p'>as per your needs, without any risk</p>
                </div>

                <div className='price-contain1'>
                    <div className="pricing-card">
                        <div className="pricing-amount">
                            <span className='price-span'>Starting from</span>
                            <span className="price">Rs.99 /User/Month</span>
                        </div>
                        <div className="pricing-benefits">
                            <ul className='price-ul'>
                                <li className='price-li'>✓ Ideal for small teams.</li>
                                <li className='price-li'>✓ No contractual lock-in period.</li>
                                <li className='price-li'>✓ No hidden charges.</li>
                                <li className='price-li'>✓ Transparent pricing.</li>
                            </ul>
                        </div>
                        <button className="get-quote-btn">Get Price Quote Now</button>
                    </div>

                    <div className="pricing-card popular">
                        <div className="badge">Most Popular</div>
                        <div className="pricing-amount">
                            <span className='price-span'>Starting from</span>
                            <span className="price">Rs.199 /User/Month</span>
                        </div>
                        <div className="pricing-benefits">
                            <ul className='price-ul'>
                                <li className='price-li'>✓ Best for growing teams.</li>
                                <li className='price-li'>✓ Includes advanced features.</li>
                                <li className='price-li'>✓ Priority support.</li>
                                <li className='price-li'>✓ Transparent pricing.</li>
                            </ul>
                        </div>
                        <button className="get-quote-btn">Get Price Quote Now</button>
                    </div>

                    <div className="pricing-card">
                        <div className="pricing-amount">
                            <span className='price-span'>Starting from</span>
                            <span className="price">Rs.299 /User/Month</span>
                        </div>
                        <div className="pricing-benefits">
                            <ul className='price-ul'>
                                <li className='price-li'>✓ Premium for large teams.</li>
                                <li className='price-li'>✓ Dedicated manager.</li>
                                <li className='price-li'>✓ Exclusive add-ons.</li>
                                <li className='price-li'>✓ Priority support.</li>
                            </ul>
                        </div>
                        <button className="get-quote-btn">Get Price Quote Now</button>
                    </div>
                </div>
            </div>

            {/* faq-container */}

            <div className='faq-outer'>
                <div className="faq-container">
                    <h2 className="faq-title">Frequently <span>Asked Questions</span></h2>
                    {faqs.map((faq, index) => (
                        <div key={index} className="faq-item">
                            <div
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                            >
                                {faq.question}
                                <span className={`arrow ${openIndex === index ? 'open' : ''}`}>&#x25BE;</span>
                            </div>
                            <div
                                className={`faq-answer ${openIndex === index ? 'open' : ''}`}
                            >
                                {faq.answer}
                            </div>
                            <hr />
                        </div>
                    ))}
                </div>
            </div>

            {/* footer */}

            <div className="footer-copyright">
                <p>
                    Copyright © 2025
                    <a href="https://www.ambrosyscorp.com" className='cp-a' target="_blank" rel="noopener noreferrer">
                        Ambrosys Business Solutions Pvt. Ltd.
                    </a>
                    — All rights reserved.
                </p>
            </div>

        </div>
    );
};
export default Login;